exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "button[data-v-54f5ede2]{transition:all .2s;display:flex;justify-content:center}button[data-v-54f5ede2]:disabled{pointer-events:none;opacity:.6}button .checkmark[data-v-54f5ede2]{display:flex;justify-content:center;align-items:center;width:20px;margin-left:15px}button .checkmark[data-v-54f5ede2]:after{content:\"\";display:block;width:10px;height:18px;margin-top:-10px;border:solid #fff;border-width:0 2px 2px 0;transform:rotate(45deg)}", ""]);

// exports
